import {isEventDetailsPageHiddenInternal, isEventRsvpButtonVisible, isExternal} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React, {MouseEventHandler} from 'react'
import {useWidgetActions, useWidgetRuntimeContext, useWidgetState} from '../../hooks/state-provider'
import {getEventDetailsPageUrl, getEventUrl, isEventRestricted} from '../../selectors/events'
import {LinkToPageProps} from './interface'
import s from './link-to-page.scss'

export const LinkToPage = ({
  dataHook,
  style,
  className,
  children,
  focusable = true,
  dataAnchor,
  hasAdditionalInfoToggle,
  event,
  allowExternal,
}: LinkToPageProps) => {
  const state = useWidgetState(st => st)
  const actions = useWidgetActions()
  const {baseUrl, pageUrl, queryParams} = useWidgetRuntimeContext()

  const isRestricted = isEventRestricted(state, event)
  const url = allowExternal
    ? getEventUrl(state, event, baseUrl, pageUrl?.relativeUrl, queryParams)
    : getEventDetailsPageUrl(state, event, baseUrl, pageUrl?.relativeUrl, queryParams)
  const disabled = (hasAdditionalInfoToggle && !url) || !isEventRsvpButtonVisible(event)
  const isExternalUrl = allowExternal && isExternal(event) && isEventDetailsPageHiddenInternal(event)

  let onClick: MouseEventHandler
  if (hasAdditionalInfoToggle) {
    onClick = e => e.preventDefault()
  } else if (url) {
    onClick = _e => actions.onLinkNavigatedToPage({event})
  } else {
    onClick = e => {
      if (isRestricted) {
        e.stopPropagation()
      }
      actions.navigateToPage({event})
    }
  }

  if (disabled) {
    return <div className={className}>{children}</div>
  }

  return (
    <a
      tabIndex={focusable ? 0 : -1}
      data-hook={dataHook}
      style={style}
      className={classNames(s.root, className)}
      href={url}
      target={isExternalUrl ? '_blank' : undefined}
      rel={isExternalUrl ? 'nofollow' : ''}
      onClick={onClick}
      data-anchor={dataAnchor}
    >
      {children}
    </a>
  )
}
